export const keycloakUrl = process.env.REACT_APP_KEYCLOAK_URL;
export const keycloakRealm = process.env.REACT_APP_KEYCLOAK_REALM;
export const keycloakClientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
